import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css'

import Switches from 'vue-switches'
Vue.component('switches', Switches)

import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 5,
  newestOnTop: true
})

import PrettyCheck from 'pretty-checkbox-vue/check'
import PrettyRadio from 'pretty-checkbox-vue/radio'
import 'pretty-checkbox/src/pretty-checkbox.scss'
Vue.component('p-check', PrettyCheck)
Vue.component('p-radio', PrettyRadio)

import 'v-title/lib/element-ui'
import VTitle from 'v-title'
Vue.use(VTitle)

import "vue-mapbox/dist/vue-mapbox.css"
import "mapbox-gl/dist/mapbox-gl.css"
// import * as turf from "@turf/turf"
// Object.defineProperty(Vue.prototype, '$turf', { value: turf })

import { Socket } from 'vue-loading-spinner'
Vue.component('loader', Socket)

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
Vue.component('vue-slider', VueSlider)

import VueResource from 'vue-resource'
Vue.use(VueResource)
Vue.http.headers.common['Content-Type'] = 'application/json'
// Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
// Vue.http.headers.common['Accept'] = 'application/json, text/plain, */*'
// Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'
/*"Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",
        "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
        "Access-Control-Allow-Origin": "*"*/

// import VueAxios from 'vue-axios'
// import VueAuthenticate from 'vue-authenticate'
// import axios from 'axios'
// export function getRedirectUri(uri) {
//   try {
//     return (!isUndefined(uri))
//       ? `${$window.location.origin}${uri}`
//       : $window.location.origin
//   } catch (e) {}

//   return uri || null;
// }
// Vue.use(VueAxios, axios)
// Vue.use(VueAuthenticate, {
//   baseUrl: 'http://localhost:8080',
//   providers: {
//     facebook: {
//       name: 'facebook',
//       url: '/auth/facebook',
//       authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
//       redirectUri: getRedirectUri('/'),
//       requiredUrlParams: ['display', 'scope'],
//       scope: ['email'],
//       scopeDelimiter: ',',
//       display: 'popup',
//       oauthType: '2.0',
//       popupOptions: { width: 580, height: 400 },
//       appID: '732753237456889',
//       appSecret: '2030c5596278c61f158a103f94fbfa76'
//     },
//     google: {
//       name: 'google',
//       url: '/auth/google',
//       authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
//       redirectUri: getRedirectUri(),
//       requiredUrlParams: ['scope'],
//       optionalUrlParams: ['display'],
//       scope: ['profile', 'email'],
//       scopePrefix: 'openid',
//       scopeDelimiter: ' ',
//       display: 'popup',
//       oauthType: '2.0',
//       popupOptions: { width: 452, height: 633 }
//     },
//     linkedin: {
//       name: 'linkedin',
//       url: '/auth/linkedin',
//       authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
//       redirectUri: getRedirectUri(),
//       requiredUrlParams: ['state'],
//       scope: ['r_emailaddress'],
//       scopeDelimiter: ' ',
//       state: 'STATE',
//       oauthType: '2.0',
//       popupOptions: { width: 527, height: 582 }
//     }
//   }
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
